<template>
  <div class = "heads">
    <div class = "big-center">
      <div class = "center">
        <div class = "cont left">
          <img class = "logos" src = "../assets/foot/logos.png"/>
        </div>
        <div class = "cont conter">
          <div class = "names">{{ company }}</div>
          
          <div class = "weixin">{{ $t('foots.contactAddress') }}：{{ address }}</div>
		  <div class = "weixin">{{ $t('foots.customerService') }}：{{ weixin }}</div>
        </div>
        <div class = "cont right">
          <div class = "xcx">
            <img class = "erweima" :src = "QRcode"/>
            <div class = "saoma">{{ $t('foots.QRcode') }} <br/>{{ $t('foots.obtain') }}</div>
          </div>
          <!-- <div class = "xcx">
            <img class = "erweima" :src = "downcode"/>
            <div class = "saoma">{{ $t('foots.QRcode') }} <br/>{{ $t('foots.operatedMallApp') }}</div>
          </div> -->
        </div>
      </div>
    </div>
	<section class = "copyright-section">
		<p>Copyright &copy; {{ company }}. {{ $t('foots.copyright') }}.</p>
		<a href = "http://www.beian.gov.cn/">
			<p>{{beianhao}}</p>
		</a>
	</section>
  </div>
</template>

<script>
export default {
	name: 'Foots',
	data() {
		return {
			QRcode: '../assets/foot/xcx.png',
			downcode: '../assets/foot/app.png',
			company: '成都皖川家俱有限公司',
			address: '陕西省西安市雁塔区高新四路朗臣大厦11808室',
			weixin: 'maxdlln',
			beianhao: '',
			version:'en',
		}
	},
	mounted() {
		if(!this.$cookie.get('language')){
			this.$i18n.locale = 'en'
			this.$cookie.set('language', 'en')
		}
		this.getCode()
		var version = this.version
		setInterval(() => {
			version = this.$cookie.get('language')
			if(version!=this.version){
				this.version = version
				this.getCode()
			}
		}, 1000)
		
		
	},
	created() {
		this.getCode()
	},
	methods: {
		goAbute(url) {
			console.log('url', url)
			uni.navigateTo({
				url: url
			})
		},
		getCode() {
			
			// this.$http({
			// 	url: this.$http.adornUrl('/common/type/281'), //app下载地址
			// 	method: 'get',
			// }).then(({data}) => {
			// 	if(data.data){
			// 		window.localStorage.setItem("downcode",data.data.value);
			// 		this.downcode = data.data.value
			// 	}
				
			// })
			if(this.version=='en'){
				this.$http({
					url: this.$http.adornUrl('/common/type/409'),//公司名称
					method: 'get',
				}).then(({data}) => {
					if(data.data){
						this.company = data.data.value
					}
					
				})
				this.$http({
					url: this.$http.adornUrl('/common/type/410'), //公司地址
					method: 'get',
				}).then(({data}) => {
					if(data.data){
						this.address = data.data.value
					}
					
				})
				this.$http({
					url: this.$http.adornUrl('/common/type/411'),	//备案号
					method: 'get',
				}).then(({data}) => {
					if(data.data){
						this.beianhao = data.data.value
					}
					
				})
				this.$http({
					url: this.$http.adornUrl('/common/type/412'), //手机号
					method: 'get',
				}).then(({data}) => {
					if(data.data){
						this.weixin = data.data.value
					}
					
				})
				this.$http({
					url: this.$http.adornUrl('/common/type/413'), //小程序二维码
					method: 'get',
				}).then(({data}) => {
					if(data.data){
						window.localStorage.setItem("QRcode",data.data.value);
						this.QRcode = data.data.value
					}
					
				})
			}else{
				this.$http({
					url: this.$http.adornUrl('/common/type/282'),//公司名称
					method: 'get',
				}).then(({data}) => {
					if(data.data){
						this.company = data.data.value
					}
					
				})
				this.$http({
					url: this.$http.adornUrl('/common/type/283'), //公司地址
					method: 'get',
				}).then(({data}) => {
					if(data.data){
						this.address = data.data.value
					}
					
				})
				this.$http({
					url: this.$http.adornUrl('/common/type/284'),	//备案号
					method: 'get',
				}).then(({data}) => {
					if(data.data){
						this.beianhao = data.data.value
					}
					
				})
				this.$http({
					url: this.$http.adornUrl('/common/type/285'), //手机号
					method: 'get',
				}).then(({data}) => {
					if(data.data){
						this.weixin = data.data.value
					}
					
				})
				this.$http({
					url: this.$http.adornUrl('/common/type/286'), //小程序二维码
					method: 'get',
				}).then(({data}) => {
					if(data.data){
						window.localStorage.setItem("QRcode",data.data.value);
						this.QRcode = data.data.value
					}
					
				})
			}
			
		}

	}
}
</script>
<style scoped = "scoped">
.big-center {
	width: 100%;
	height: 245px;
	line-height: 24px;
	color: #fff;
	font-size: 14px;
	background: #78aadd;
}

.center {
	width: 1200px;
	margin: 0 auto;
}

.cont {
	display: inline-block;
	font-size: 14px;
}

.left {
	text-align: left;
	margin-left: 5%;
	position: relative;
	top: 30px;
}

.left img {
	width: 82%;
	position: relative;
	bottom: 30px;
}

.conter {
	text-align: left;
	width: 33%;
	line-height: 30px;
	margin-top: 50px;
}

.names {
	font-size: 20px;
}

.right {
	width: 38%;
	padding-top: 5%;


}

.right .xcx {
	display: inline-block;
	text-align: center;
	width: 60%;
	margin-left: 9%;
	/* padding: 2% 10%; */
}

.right .xcx img {
	width: 28%;

}

.saoma {
	text-align: center;
}

.copyright-section {
	background: #fff;
}

.copyright-section p {
	color: #999999;
}

.copyright-section p span {
	color: #cccccc;
}

.copyright-section {
	padding: 30px 0;
	text-align: center;
	background: #78aadd;
}

.copyright-section p {
	margin-bottom: 0;
	font-size: 10px;
	text-transform: uppercase;
	color: #fff;
	font-family: 'Montserrat', sans-serif;
}

.copyright-section p span {
	color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/foots.vue